/* eslint-disable @typescript-eslint/no-explicit-any */

import { isMatching, P } from "ts-pattern";

export function isMatchingN<Q extends P.Pattern<any>, V>(pattern: Q, value: V) {
    if (isMatching(pattern, value)) {
        return value;
    }
}
